<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { Route } from "tinro";
  import date from 'date-and-time';
  import cs from 'date-and-time/locale/cs';
  import Select from 'svelte-select';
  import AutoComplete from "simple-svelte-autocomplete";
  import { DateInput } from 'date-picker-svelte';
  import {
    Popover,
    PopoverButton, PopoverGroup,
    PopoverPanel,
  } from "@rgossiaux/svelte-headlessui";
  import ChildMenu from './../../../../components/menu/ChildMenu.svelte';
  import EventForm from './form/Event.svelte';
  import {
    calendars as default_calendars_store,
    regions as default_regions_store
  } from './stores.js';
  
  const dispatch = createEventDispatcher();
  
  const defaultDay = {title: {cs: ""}, subtitle: {cs: ""}, key: "", visible: true, date: null};
  const dayNames = {cs: {0: "Neděle", 1: "Pondělí", 2: "Úterý", 3: "Středa", 4: "Čtvrtek", 5: "Pátek", 6: "Sobota" } }
  const groupBy = (item) => item.parent_name;
  const dayKeyFormat = "DDMMY";
  const dayJsonFormat = "YYYY-MM-DD";
  
  export let locale = 'cs';
  export let user = null;
  
  let visible_event_form = false;
  
  let events = null;
  let event = null;
  
  let selected_day = null;
  let selected_calendar = null;
  let selected_region = null;
  let calendars = [];
  let regions = [];
  
  let days = [];
  let current_day = 0;
  let max_amount_of_events = 15;
  
  let now = new Date();
  
  date.locale(cs);
  
  $: days = [ makeDay(current_day, selected_day),
              makeDay(current_day+1, selected_day),
              makeDay(current_day+2, selected_day),
              makeDay(current_day+3, selected_day)
            ];
  
  function riseEventsAmount() {
    for (const devents of events)
      if (devents.length > max_amount_of_events)
        max_amount_of_events = devents.length;
  }
  
  function selectToday() {
    selected_day = null;
    current_day = 0;
  }
  
  function selectDay(d) {
    selected_day = d.detail;
    current_day = 0;
  }
  
  function makeDay(daysFromToday, selected_date=null) {
    var origin = now;
    if (selected_date) {
      origin = selected_date;
    }
    let d = Object.assign({}, defaultDay, {date: date.addDays(origin, daysFromToday), visible: true})
    d.title = date.format(d.date, 'dddd')
    d.subtitle = date.format(d.date, 'D. MMMM Y')
    d.key = date.format(d.date, dayKeyFormat);
  
    if (events != null) {
      let day_events = events[d.key];
      if (!day_events || !day_events.length) {
        getEvents(d.date, null, (data) => {
          data.map((e) => {
            addEvent(e)
          });
        });
      }
    }
    return d
  }
  
  
  function selectCalendar() {
    if (!calendars.length)       return;
    events = {};
    loadEvents();
  }
  
  function selectRegion() {
    if (!regions.length)       return;
    events = {};
    loadEvents();
  }
  
  function loadEvents() {
    getEvents(days[0].date, days[days.length-1].date, (data) => {
      data.map((e) => {
        addEvent(e)
      });
      sortEvents();
    });
  }
  
  function getEvents(started, ended, setFunction) {
    let url = `/p/c/events/${date.format(started, dayJsonFormat)}`;
    if (ended)
      url = url + `/${date.format(ended, dayJsonFormat)}`;
    url = url + `.json?1`;
    if (selected_calendar)
      url = url + `&calendar=${window.atob(selected_calendar.id)}`;
    if (selected_region)
      url = url + `&region=${window.atob(selected_region.id)}`;
  
    fetch(url)
      .then(function(r) {
        if (r.ok) return r.json();
        if (r.code == 404) return {data: []};
      })
      .then(data => {
        if (!Array.isArray(data.data))
          data.data = [data.data];
        if (setFunction)
          setFunction(data.data);
        riseEventsAmount();
      })
      .catch(resp => {
        if (setFunction)
          setFunction([]);
      });
  }
  
  function toggleEventForm() {
    visible_event_form = !visible_event_form;
  }
  
  
  function addEvent(e) {
    if (events == null)
      events = {};
  
    if (e && e.started_at)  {
      let start_at = date.parse(e.started_at, 'YYYY-MM-DD HH:mm:ss')
      let dmy = date.format(start_at, dayKeyFormat);
      e.time = date.format(start_at, 'HH:mm');
      if (dmy in events) {
        let exists = false;
        for (const eve of events[dmy]) {
          exists = e['id'] && e['id'] == eve['id'];
          if (exists)
            break;
        }
        if (!exists)
          events[dmy].push(e);
      }
      else
        events[dmy] = [e];
      sortEvents(dmy);
      events = events;
      if (events[dmy].length > max_amount_of_events)
        max_amount_of_events = events[dmy].length;
    }
  }
  
  function sortEvents(dmy) {
    if (dmy) {
      events[dmy].sort((a, b) => {
        if (a.time == b.time)
          return 0;
        return a.time < b.time ? -1 : 1
      })
    }
    else {
      for (dmy in events)
        sortEvents(dmy);
    }
  }
  
  function onEvent(e) {
    visible_event_form = false;
    addEvent(e);
  }
  
  onMount(() => {
    getUser();
    default_calendars_store.subscribe(value => {
      if (value  != 'undefined' || !value)
        calendars = value;
    });
    default_regions_store.subscribe(value => {
      if (value  != 'undefined' || !value) {
        regions = [];
        var map = {}, i, list = [];
        for (i = 0; i < value.length; i++)
          map[ value[i].id ] = value[i]; // initialize the map
        for (i = 0; i < value.length; i++) {
          if (value[i].parent_id && value[i].parent_id !== null) {
            value[i].parent_name = map[ value[i].parent_id ].name; // initialize the map
            list.push(value[i])
          }
        }
        regions = list;
      }
    });
  })
  
  function getUser() {
    fetch(`/user.jsr`)
      .then(function(r) {
        if (r.ok) return r;
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        user = data.data[0]
      })
      .catch(function(error) {
        console.log(error);
      });
  }
</script>
<nav class='navbar navbar-light bg-white justify-content-between shadow-sm'>
<ul class='nav flex-row'>
<li class='nav-item'>
<a class='nav-link' href='/' tinro-ignore title='Informační servis'>
<i class='fas fa-external-link-alt'></i>
Obsah
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/c' tinro-ignore title='Kalendář'>
<i class='far fa-calendar-alt'></i>
Kalendář
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/w' tinro-ignore title='Počasí ČR'>
<i class='wi wi-day-sunny-overcast'></i>
Počasí
</a>
</li>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/f' rel='nofollow' tinro-ignore title='Odběry novinek'>
<i class='fa fa-star'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-primary' href='/a' rel='nofollow' tinro-ignore title='Strojová analýza textového obsahu'>
<i class='fa fa-graduation-cap'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/nlp' rel='nofollow' tinro-ignore title='Tvorba analytických modelů'>
<i class='fa fa-chalkboard-teacher'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/kb' rel='nofollow' tinro-ignore title='Znalostní báze'>
<i class='fa fa-book'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/e' rel='nofollow' tinro-ignore title='Editor'>
<i class='fa fa-edit'></i>
</a>
</li>
{/if}
<li class='nav-item'>
<a class='nav-link' href='/info' rel='nofollow' tinro-ignore>
<i class='fa fa-info'></i>
</a>
</li>
</ul>
<ul class='nav flex-row'>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/profile' rel='nofollow' tinro-ignore title='Nastavení'>
<i class='fa fa-cog'></i>
</a>
</li>
{:else}
<li class='nav-item'>
<a class='nav-link text-primary' href='/html/account.html' rel='nofollow' tinro-ignore>Přihlášení</a>
</li>
{/if}
</ul>

</nav>
<div class='container-fluid'>
<div class='d-flex flex-row'>
<div class='d-flex flex-column flex-shrink-1Internet'>
{#if !visible_event_form}
<div class='d-flex justify-content-start flex-column'>
{#if user}
<a class='btn btn-link text-primary text-decoration-none pt-3 pt-3' on:click='{toggleEventForm}'>
<i class='fa fa-plus'></i>
</a>
{:else}
<div class='mt-5' title='Dnes'></div>
{/if}
<a class='btn btn-link text-decoration-none pt-3 pt-3' on:click='{selectToday}' title='Mít dnes'>
<i class='fa fa-calendar-day'></i>
</a>
</div>
{:else}
<EventForm calendars='{calendars}' event='{event}' on:event='{onEvent}' regions='{regions}'></EventForm>
{/if}
</div>
<div class='flex-fill'>
<div class='d-flex justify-content-start flex-row my-2'>
<div class='m-1 w-auto'>
<DateInput bind:value='{selected_day}' browseWithoutSelecting='{true}' class='ui' closeOnSelection='{true}' format='dd/MM/yy' locale='{cs}' on:select='{selectDay}' placeholder='Kdy'></DateInput>
</div>
<div class='m-1 w-auto'>
{#if regions.length}
<AutoComplete bind:selectedItem='{selected_region}' className='font-weight-bold text-dark' inputClassName='ui form-control text-dark' items='{regions}' labelFieldName='name' matchAllKeywords='{false}' onChange='{selectRegion}' placeholder='Kde' showClear sortByMatchedKeywords='{true}'></AutoComplete>
{/if}
</div>
<div class='m-1 w-auto'>
<AutoComplete bind:selectedItem='{selected_calendar}' className='font-weight-bold text-dark' inputClassName='ui form-control text-dark' items='{calendars}' labelFieldName='name' matchAllKeywords='{false}' onChange='{selectCalendar}' placeholder='Co' showClear sortByMatchedKeywords='{true}'></AutoComplete>
</div>
</div>
<div class='m-1 p-2 shadow-sm bg-white d-flex flex-row'>
<div class='d-block pntr'>
<i class='fa fa-arrow-left' on:click='{() => current_day = current_day - 1}'></i>
</div>
<div class='d-flex flex-row w-100'>
{#key events}
{#each days as day, i}
{#if day.visible}
<div class='w-25 h-100'>
<h3 class='text-center text-uppercase'>{day.title}</h3>
<h6 class='text-center text-monospace'>{day.subtitle}</h6>
<PopoverGroup>
<ol class='events list-group list-group-flush mt-2 py-0 px-3'>
{#each {length: max_amount_of_events} as _, i}
{#if events && events[day.key] && i < events[day.key].length }
<li class='p-1 list-group-item' style='color: {events[day.key][i].color}; background: {events[day.key][i].background}'>
<Popover style='position: relative; width: 100%'>
<div class='d-flex flex-row p-1 justify-content-between'>
<time class='badge badge-light'>
{ events[day.key][i].time }
</time>
<time class='badge badge-light'>
{ events[day.key][i].municipality_name }
</time>
</div>
<div class='m-1 font-weight-bold'>
<PopoverButton as='span' style='cursor: pointer'>
{ events[day.key][i].name }
</PopoverButton>
</div>
<div class='d-flex justify-content-between'>
<span class='badge badge-link font-weight-light'>
{ events[day.key][i].location_name }
</span>
{#if events[day.key][i].about}
<PopoverButton as='span' style='cursor: pointer'>
<i class='fa fa-info'></i>
</PopoverButton>
{/if}
</div>
{#if events[day.key][i].about}
<PopoverPanel style='position: absolute; z-index: 10; width: 100%'>
<div class='popover'>
<div class='popover-body'>
{ events[day.key][i].about }
</div>
</div>
</PopoverPanel>
{/if}
</Popover>
</li>
{:else}
<li class='p-1 list-group-item'>
&nbsp;
</li>
{/if}
{/each}
</ol>
</PopoverGroup>
</div>
{/if}
{/each}
{/key}
</div>
<div class='d-block pntr'>
<i class='fa fa-arrow-right' on:click='{() => current_day = current_day + 1}'></i>
</div>
</div>
</div>
</div>
</div>
